import { Brick, registerBrick } from 'olympe'

export default class PrepareRolesPOST extends Brick {
    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input (userToken) is undefined.
     *
     * @protected
     * @param {BrickContext} context
     * @param {string} userToken
     * @param {function()} forwardEvent
     * @param {function(*)} setBody
     */
    onUpdate(context, [userToken], [forwardEvent, setBody]) {
        const encodedToken = encodeURIComponent(userToken)
        let body = {
            authorization: encodedToken,
        }
        setBody(body)
        forwardEvent()
    }
}

registerBrick('017bc43d529d604bf336', PrepareRolesPOST)
